'use strict';

const config = require('../utils/config.js');
const logger = require('../utils/logger.js');


const classNames = {
    eu: 'eu',
    privacySettings: 'privacy-settings',
    us: 'us'
};

module.exports = {
	init: function (consentType) {
		const $euPrivacyLink = $.findByBem(classNames.privacySettings, null, classNames.eu);
		const $usPrivacyLink = $.findByBem(classNames.privacySettings, null, classNames.us);
		
		if (consentType === 'gdpr') {
			$euPrivacyLink.show();

			$euPrivacyLink.on('click.footer', function (e) {
				e.preventDefault();
				if (window._sp_ && window._sp_.gdpr.loadPrivacyManagerModal) {
					window._sp_.gdpr.loadPrivacyManagerModal(config.euPrivacyManagerId);
				} else {
					logger.debug('CMP: Sourcepoint privacy manager script not loaded');
				}
			});
		}
		
		else if (consentType === 'usnat') {
			$usPrivacyLink.show();
			
			$usPrivacyLink.on('click.footer', function (e) {
				
				e.preventDefault();
				if (window._sp_ && window._sp_.usnat.loadPrivacyManagerModal) {
					window._sp_.usnat.loadPrivacyManagerModal(config.usPrivacyManagerId);
				} else {
					logger.debug('CMP: Sourcepoint privacy manager script not loaded');
				}
			});
			
		} else {
			$(document).on('tcf.privacymanager', function (event, data) {
				const $visibleLink = data.gdprApplies ? $euPrivacyLink : $usPrivacyLink;
				$visibleLink.parent().removeBemClass('site-footer__nav', 'item', 'hidden');
			});
		}
	}
}
